export default __webpack_public_path__ + "static/media/junaid.9c2449d2.jpg";